import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const EducationSection = () => {
  const { isDark } = useTheme();

  const educationData = [
    {
      institution: "Institut Bisnis dan Informatika Kesatuan",
      major: "S1 - Teknologi Informasi",
      period: "Saat Ini",
      status: "Mahasiswa Aktif",
      badgeColor: isDark ? "bg-blue-700 text-blue-100" : "bg-blue-600 text-white"
    },
    {
      institution: "SMK Wikrama Bogor",
      major: "Pengembangan Perangkat Lunak & GIM",
      period: "Lulus",
      status: "Alumni",
      badgeColor: isDark ? "bg-green-800 text-green-100" : "bg-green-600 text-white"
    }
  ];

  const titleColor = isDark ? 'text-white' : 'text-gray-800';
  const skyColor = isDark ? 'bg-blue-600' : 'bg-sky-600';
  const cardBg = isDark ? 'bg-[#0D1520]' : 'bg-white';
  const institutionColor = isDark ? 'text-slate-100' : 'text-gray-800';
  const majorColor = isDark ? 'text-blue-400' : 'text-blue-600';
  const dividerColor = isDark ? 'border-[#1E3A5F]' : 'border-gray-100';

  return (
    <div className="mt-5">
      <h4 className={`text-lg font-semibold ${titleColor} mb-3 flex items-center`}>
        <div className={`w-4 h-4 ${skyColor} mr-2 flex-shrink-0`} />
        Riwayat Pendidikan
      </h4>
      <div className={`${cardBg} pixel-border p-4 space-y-3`}>
        {educationData.map((edu, index) => (
          <div 
            key={index} 
            className={`flex items-start justify-between gap-3 pb-3 border-b-2 border-dashed ${dividerColor} last:border-b-0 last:pb-0`}
          >
            <div className="space-y-1">
              <h5 className={`font-bold ${institutionColor} text-sm md:text-base`}>{edu.institution}</h5>
              <p className={`text-xs md:text-sm ${majorColor} font-medium`}>{edu.major}</p>
            </div>
            <span className={`text-xs px-2 py-1 font-semibold shrink-0 pixel-border ${edu.badgeColor}`}>
              {edu.period}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EducationSection;
